/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import './pagination';
import '../model/shared/device_profile_type';
import './status';
import '../model/device_profile_link';
import '../model/shared/device_profile_link';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "message": {
                    "nested": {
                      "GetDeviceProfileLinksV2Request": {
                        "fields": {
                          "pagination": {
                            "type": ".squareup.devicesettings.profiles.v2.message.Pagination",
                            "id": 1,
                            "rule": "optional"
                          },
                          "deviceProfileType": {
                            "type": ".squareup.devicesettings.profiles.v2.model.shared.DeviceProfileType",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "GetDeviceProfileLinksV2Response": {
                        "fields": {
                          "status": {
                            "type": ".squareup.devicesettings.profiles.v2.message.Status",
                            "id": 1,
                            "rule": "optional"
                          },
                          "deviceProfileLinks": {
                            "type": ".squareup.devicesettings.profiles.v2.model.DeviceProfileLink",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "nextCursor": {
                            "type": "uint32",
                            "id": 3,
                            "rule": "optional"
                          },
                          "links": {
                            "type": ".squareup.devicesettings.profiles.v2.model.shared.DeviceProfileLink",
                            "id": 4,
                            "rule": "repeated"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.message?.nested?.GetDeviceProfileLinksV2Request && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.message?.nested?.GetDeviceProfileLinksV2Response) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE GetDeviceProfileLinksV2Request @ squareup/devicesettings/profiles/v2/message/get_device_profile_links.proto at 15:1
 */
export const GetDeviceProfileLinksV2Request = $root.lookupType('squareup.devicesettings.profiles.v2.message.GetDeviceProfileLinksV2Request');
fixType(GetDeviceProfileLinksV2Request);
Builder.createAndAttachToType(GetDeviceProfileLinksV2Request);
/**
 * SOURCE GetDeviceProfileLinksV2Response @ squareup/devicesettings/profiles/v2/message/get_device_profile_links.proto at 20:1
 */
export const GetDeviceProfileLinksV2Response = $root.lookupType('squareup.devicesettings.profiles.v2.message.GetDeviceProfileLinksV2Response');
fixType(GetDeviceProfileLinksV2Response);
Builder.createAndAttachToType(GetDeviceProfileLinksV2Response);